import styled from 'styled-components';

export const PlatformTabsScroller = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
`;
